const MENU_LIST = {
  'DATA_REPORT': {
    name: "数据报表",
    url: "/home",
    keyword: "DATA_REPORT",
  },
  'DATA_REPORT_data_summary':{
    name: "数据总表",
    url: "/home/data-report/warehouseDimension",
    keyword: "DATA_REPORT_data_summary",
    commonUrl: "/home/data-report",
  },
  'DATA_REPORT_profit_statement': {
    name: "盈利报表",
    url: "/home/profitIndex",
    keyword: "DATA_REPORT_profit_statement",
    commonUrl: "/home/profitIndex",
  },
  'DATA_REPORT_quality_report': {
    name: "质量报表",
    url: "/home/production-data/shipment-data",
    keyword: "DATA_REPORT_quality_report",
    commonUrl: "/home/production-data",
  },
  'DATA_REPORT_efficiency_report': {
    name: "效率报表",
    url: "/home/efficiency-report-index/efficiency-report",
    keyword: "DATA_REPORT_efficiency_report",
    commonUrl: "/home/efficiency-report-index",
  },
  'SETTING': {
    name: "系统设置",
    url: "/system-settings",
    keyword: "SETTING",
  },
  'SETTING_user': {
    name: "用户管理",
    url: "/system-settings/user-manage/user-list",
    keyword: "SETTING_user",
    commonUrl: "/system-settings/user-manage",
  },
  'SETTING_biz_role': {
    name: "角色管理",
    url: "/system-settings/role-manage-index/role-manage",
    keyword: "SETTING_biz_role",
    commonUrl: "/system-settings/role-manage-index",
  },
  'SETTING_base_info': {
    name: "基础资料",
    url: "/system-settings/baseDataIndex",
    keyword: "SETTING_base_info",
    commonUrl: "/system-settings/baseDataIndex",
  },
  'SETTING_base_info_extra_service': {
    name: "增值服务维护",
    url: "/system-settings/baseDataIndex/addServiceMaintenance",
    keyword: "SETTING_base_info_extra_service",
    commonUrl: "/system-settings/baseDataIndex/addServiceMaintenance",
  },
  'SETTING_customer': {
    name: "货主管理",
    url: "/system-settings/customer-manage-index",
    keyword: "SETTING_customer",
    commonUrl: "/system-settings/customer-manage-index",
  },
  'SETTING_customer_information': {
    name: "客户信息",
    url: "/system-settings/customer-manage-index/customer-list",
    keyword: "SETTING_customer_information",
    commonUrl: "/system-settings/customer-manage-index/customer-list",
  },
  'SETTING_customer_project': {
    name: "项目信息",
    url: "/system-settings/customer-manage-index/project-manage-index",
    keyword: "SETTING_customer_project",
    commonUrl: "/system-settings/customer-manage-index/project-manage-index",
  },
  'SETTING_customer_goods': {
    name: "商品信息",
    url: "/system-settings/customer-manage-index/goods-info",
    keyword: "SETTING_customer_goods",
    commonUrl: "/system-settings/customer-manage-index/goods-info",
  },
  'SETTING_warehouse': {
    name: "仓库管理",
    url: "/system-settings/warehouse-manage-index",
    keyword: "SETTING_warehouse",
    commonUrl: "/system-settings/warehouse-manage-index",
  },
  'SETTING_warehouse_information': {
    name: "仓库基础信息",
    url: "/system-settings/warehouse-manage-index/base-info",
    keyword: "SETTING_warehouse_information",
    commonUrl: "/system-settings/warehouse-manage-index/base-info",
  },
  'SETTING_warehouse_location': {
    name: "仓库库位",
    url: "/system-settings/warehouse-manage-index/warehouse-location",
    keyword: "SETTING_warehouse_location",
    commonUrl: "/system-settings/warehouse-manage-index/warehouse-location",
  },
  'SETTING_warehouse_information_dept_info': {
    name: "部门信息",
    url: "/system-settings/warehouse-manage-index/department-info",
    keyword: "SETTING_warehouse_information_dept_info",
    commonUrl: "/system-settings/warehouse-manage-index/department-info",
  },
  'SETTING_supplier_manager': {
    name: "供应商管理",
    url: "/system-settings/supplier-manage-index",
    keyword: "SETTING_supplier_manager",
    commonUrl: "/system-settings/supplier-manage-index",
  },
  'SETTING_supplier_manager_hr': {
    name: "人力资料",
    url: "/system-settings/supplier-manage-index/supplier-human-resources",
    keyword: "SETTING_supplier_manager_hr",
    commonUrl: "/system-settings/supplier-manage-index/supplier-human-resources",
  },
  'SETTING_supplier_manager_lr': {
    name: "物流资源",
    url: "/system-settings/supplier-manage-index/supplier-logistics-index",
    keyword: "SETTING_supplier_manager_lr",
    commonUrl: "/system-settings/supplier-manage-index/supplier-logistics-index",
  },
  'SETTING_other_cost': {
    name: "成本信息",
    url: "/system-settings/cost-info-index/cost-info",
    keyword: "SETTING_other_cost",
    commonUrl: "/system-settings/cost-info-index",
  },
  'OPERATION': {
    name: "运营管理",
    url: "/operate",
    keyword: "OPERATION",
  },
  'OPERATION_financial': {
    name: "应收款管理",
    url: "/operate/finance",
    keyword: "OPERATION_financial",
    commonUrl: "/operate/finance",
  },
  'OPERATION_financial_receivables_management': {
    name: "客户账单",
    url: "/operate/finance/customerBill",
    keyword: "OPERATION_financial_receivables_management",
    commonUrl: "/operate/finance/customerBill",
  },
  'OPERATION_financial_receivables_management_logistics_check': {
    name: "物流核验",
    url: "/operate/finance/logisticsVerification",
    keyword: "OPERATION_financial_receivables_management_logistics_check",
    commonUrl: "/operate/finance/logisticsVerification",
  },
  'OPERATION_financial_receivables_management_logistics_check_new': {
    name: "物流核验（新）",
    url: "/operate/finance/newLogisticsVerification",
    keyword: "OPERATION_financial_receivables_management_logistics_check_new",
    commonUrl: "/operate/finance/newLogisticsVerification",
  },
  'OPERATION_financial_receivables_management_bill_generate': {
    name: "账单生成",
    url: "/operate/finance/billGenerationIndex",
    keyword: "OPERATION_financial_receivables_management_bill_generate",
    commonUrl: "/operate/finance/billGenerationIndex",
  },
  'OPERATION_financial_payables_management': {
    name: "应付款管理",
    url: "/operate/dues",
    keyword: "OPERATION_financial_payables_management",
    commonUrl: "/operate/dues",
  },
  'OPERATION_financial_payables_management_hr_bill': {
    name: "人力账单",
    url: "/operate/dues/hrBill",
    keyword: "OPERATION_financial_payables_management_hr_bill",
    commonUrl: "/operate/dues/hrBill",
  },
  'OPERATION_financial_payables_management_lr_bill': {
    name: "物流账单",
    url: "/operate/dues/logisticsBill",
    keyword: "OPERATION_financial_payables_management_lr_bill",
    commonUrl: "/operate/dues/logisticsBill",
  },
  'OPERATION_workbench': {
    name: "运营工作台",
    url: "/operate/stagingIndex",
    keyword: "OPERATION_workbench",
    commonUrl: "/operate/stagingIndex",
  },
  'PRODUCTION': {
    name: "生产管理",
    url: "/production",
    keyword: "PRODUCTION",
  },
  'PRODUCTION_inventory_job': {
    name: "库存作业",
    url: "/production/inventory-operation",
    keyword: "PRODUCTION_inventory_job",
    commonUrl: "/production/inventory-operation",
  },
  'PRODUCTION_inventory_job_real_occupied_area_input': {
    name: "实占面积录入",
    url: "/production/inventory-operation/real-area",
    keyword: "PRODUCTION_inventory_job_real_occupied_area_input",
    commonUrl: "/production/inventory-operation/real-area",
  },
  'PRODUCTION_inventory_job_check': {
    name: "盘点",
    url: "/production/inventory-operation/inventory",
    keyword: "PRODUCTION_inventory_job_check",
    commonUrl: "/production/inventory-operation/inventory",
  },
  'PRODUCTION_resource_management': {
    name: "人力资源",
    url: "/production/resource-manage",
    keyword: "PRODUCTION_resource_management",
    commonUrl: "/production/resource-manage",
  },
  'PRODUCTION_resource_management_the_human_cost': {
    name: "人力成本",
    url: "/production/resource-manage/labor-cost",
    keyword: "PRODUCTION_resource_management_the_human_cost",
    commonUrl: "/production/resource-manage/labor-cost",
  },
  'PRODUCTION_hr_tmp_clock_in': {
    name: "临时工打卡",
    url: "/production/resource-manage/temporary-sign",
    keyword: "PRODUCTION_hr_tmp_clock_in",
    commonUrl: "/production/resource-manage/temporary-sign",
  },
  'PRODUCTION_hr_tmp_spending': {
    name: "临时工支出",
    url: "/production/resource-manage/temporary-expenditure",
    keyword: "PRODUCTION_hr_tmp_spending",
    commonUrl: "/production/resource-manage/temporary-expenditure",
  },
  'PRODUCTION_resource_management_hr_files': {
    name: "人力档案",
    url: "/production/resource-manage/archives",
    keyword: "PRODUCTION_resource_management_hr_files",
    commonUrl: "/production/resource-manage/archives",
  },
  'PRODUCTION_return_of_the_homework': {
    name: "退货作业",
    url: "/production/return-operation",
    keyword: "PRODUCTION_return_of_the_homework",
    commonUrl: "/production/return-operation",
  },
  'PRODUCTION_return_of_the_homework_return_of_the_registration': {
    name: "退货登记",
    url: "/production/return-operation/return-register",
    keyword: "PRODUCTION_return_of_the_homework_return_of_the_registration",
    commonUrl: "/production/return-operation/return-register",
  },
  'PRODUCTION_return_of_the_homework_any_returns_return_report': {
    name: "退货记录",
    url: "/production/return-operation/return-list",
    keyword: "PRODUCTION_return_of_the_homework_any_returns_return_report",
    commonUrl: "/production/return-operation/return-list",
  },
  'PRODUCTION_return_of_the_homework_any_returns': {
    name: "退货处理",
    url: "/production/return-operation/return-processing",
    keyword: "PRODUCTION_return_of_the_homework_any_returns",
    commonUrl: "/production/return-operation/return-processing",
  },
  'PRODUCTION_receive_job': {
    name: "收货作业",
    url: "/production/receiving",
    keyword: "PRODUCTION_receive_job",
    commonUrl: "/production/receiving",
  },
  'PRODUCTION_receive_job_receiving_operation': {
    name: "收货登记",
    url: "/production/receiving/receiving-operation",
    keyword: "PRODUCTION_receive_job_receiving_operation",
    commonUrl: "/production/receiving/receiving-operation",
  },
  'PRODUCTION_receive_job_receipt_data_report': {
    name: "收货记录",
    url: "/production/receiving/receiving-list",
    keyword: "PRODUCTION_receive_job_receipt_data_report",
    commonUrl: "/production/receiving/receiving-list",
  },
  'PRODUCTION_value_added_services': {
    name: "增值服务",
    url: "/production/increment",
    keyword: "PRODUCTION_value_added_services",
    commonUrl: "/production/increment",
  },
  'PRODUCTION_value_added_services_operation': {
    name: "增值服务登记",
    url: "/production/increment/increment-operation",
    keyword: "PRODUCTION_value_added_services_operation",
    commonUrl: "/production/increment/increment-operation",
  },
  'PRODUCTION_value_added_services_report': {
    name: "增值服务记录",
    url: "/production/increment/increment-list",
    keyword: "PRODUCTION_value_added_services_report",
    commonUrl: "/production/increment/increment-list",
  },
  'PRODUCTION_delivery_job': {
    name: "发货作业",
    url: "/production/bulk",
    keyword: "PRODUCTION_delivery_job",
    commonUrl: "/production/bulk",
  },
  'PRODUCTION_delivery_job_operation': {
    name: "大宗出库登记",
    url: "/production/bulk/bulk-operation",
    keyword: "PRODUCTION_delivery_job_operation",
    commonUrl: "/production/bulk/bulk-operation",
  },
  'PRODUCTION_delivery_job_report': {
    name: "大宗出库记录",
    url: "/production/bulk/bulk-list",
    keyword: "PRODUCTION_delivery_job_report",
    commonUrl: "/production/bulk/bulk-list",
  },
  'PRODUCTION_delivery_order_query': {
    name: "订单查询",
    url: "/production/bulk/produce-search",
    keyword: "PRODUCTION_delivery_order_query",
    commonUrl: "/production/bulk/produce-search",
  },
  'PRODUCTION_logisti_manual_order_register': {
    name: "物流补登",
    url: "/production/bulk/logistics-supplementary-registration",
    keyword: "PRODUCTION_logisti_manual_order_register",
    commonUrl: "/production/bulk/logistics-supplementary-registration",
  },
  'PRODUCTION_logisti_manual_order_query': {
    name: "物流补登记录",
    url: "/production/bulk/manual-order-record",
    keyword: "PRODUCTION_logisti_manual_order_query",
    commonUrl: "/production/bulk/manual-order-record",
  },
  'PRODUCTION_delivery_job_production_line_manager': {
    name: "产线管理",
    url: "/production/bulk/production-line",
    keyword: "PRODUCTION_delivery_job_production_line_manager",
    commonUrl: "/production/bulk/production-line",
  },
  'PRODUCTION_delivery_order_cancel': {
    name: "订单取消记录",
    url: "/production/bulk/order-cancel",
    keyword: "PRODUCTION_delivery_order_cancel",
    commonUrl: "/production/bulk/order-cancel",
  },
  'PRODUCTION_delivery_job_team_manager': {
    name: "班组管理",
    url: "/production/bulk/team/team-details",
    keyword: "PRODUCTION_delivery_job_team_manager",
    commonUrl: "/production/bulk/team",
  },
  'PRODUCTION_claim': {
    name: "索赔",
    url: "/production/claim-index",
    keyword: "PRODUCTION_claim",
    commonUrl: "/production/claim-index",
  },
  'PRODUCTION_claim_check': {
    name: "索赔登记",
    url: "/production/claim-index/claim-register",
    keyword: "PRODUCTION_claim_check",
    commonUrl: "/production/claim-index/claim-register",
  },
  'PRODUCTION_claim_no_check_form': {
    name: "待确认表单",
    url: "/production/claim-index/tbc-record",
    keyword: "PRODUCTION_claim_no_check_form",
    commonUrl: "/production/claim-index/tbc-record",
  },
  'PRODUCTION_claim_is_check_form': {
    name: "已确认表单",
    url: "/production/claim-index/confirmed-record",
    keyword: "PRODUCTION_claim_is_check_form",
    commonUrl: "/production/claim-index/confirmed-record",
  },
  'PRODUCTION_workbench': {
    name: "生产工作台",
    url: "/production/production-workbench-index",
    keyword: "PRODUCTION_workbench",
    commonUrl: "/production/production-workbench-index",
  },
}

export default MENU_LIST